import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { configBonusHandle, configGradeList } from '@/api/apis';
export default {
  props: {
    bonusData: {
      required: true
    },
    gradeList: {
      required: true
    }
  },
  watch: {
    bonusData: function bonusData(newVal, oldVal) {
      this.conditions = JSON.parse(newVal.conditions);
    },
    deep: true,
    // 如果 bonusData 是对象或数组，需要这个
    immediate: false // 是否在初始时立即触发一次

  },
  data: function data() {
    return {
      conditions: [// {grade:1,rate:0.06},
        // {grade:2,rate:0.1},
        // {grade:3,rate:0.2},
        // {grade:4,rate:0.25},
        // {grade:5,rate:0.3},
        // {grade:6,rate:0.33},
        // {grade:7,rate:0.36},
        // {grade:8,rate:0.39},
        // {grade:9,rate:0.4},
        // {grade:10,rate:0.41},
        // {grade:11,rate:0.42},
        // {grade:12,rate:0.43},
      ]
    };
  },
  mounted: function mounted() {},
  methods: {
    clickSave: function clickSave() {
      var _this = this;

      configBonusHandle({
        id: this.bonusData.id,
        conditions: JSON.stringify(this.conditions)
      }).then(function _callee(res) {
        return regeneratorRuntime.async(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$alert('保存成功', '提示', {
                  confirmButtonText: '确定'
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        });
      });
    }
  }
};